module.exports = __webpack_public_path__ + "img/metier_visiteur.54af1ca2.png";